import React from 'react';
import { useQuery } from '@apollo/react-hooks';

import { jhMenu, jhMenuVariables } from 'src/queries/__generated__/jhMenu';
import navMenuQuery from 'src/queries/jhMenu.graphql';
import { useDeps } from 'src/hooks/useDeps';
import { StaticSpinner } from 'src/components/Layout/Spinner';
import { NavList } from 'src/components/Nav/NavList';

import classes from './Nav.scss';

const MAIN_MENU_IDENTIFIER = 'main-mega-menu';

type NavQueryProps = {
    setOverflow?: (value: boolean) => void;
};

export function NavQuery(props: NavQueryProps) {
    const { error, data, loading } = useQuery<jhMenu, jhMenuVariables>(navMenuQuery, {
        variables: { identifier: MAIN_MENU_IDENTIFIER },
        ssr: useDeps().env.SSR_GQL,
    });

    if (error) {
        console.error('could not fetch data for NavQuery', error);
        return null;
    }

    if (loading)
        return (
            <div className={classes.loader}>
                <StaticSpinner />
            </div>
        );

    if (!data || !Array.isArray(data.jhMenu)) {
        console.error('jhMenu was missing', data);
        return null;
    }

    return <NavList jhMenu={data?.jhMenu} setOverflow={props.setOverflow} />;
}

export default NavQuery;
